import { Trans } from "@lingui/react/macro";
import { LoaderCircle } from "lucide-react";

// Пустой список у нового пользователя: история матчей ещё загружается из Deadlock.
export const HistoryLoading = () => (
  <div
    role="status"
    className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-border p-6 text-center"
  >
    <LoaderCircle aria-hidden="true" className="size-6 animate-spin text-accent" />
    <p className="font-semibold">
      <Trans>Loading your match history…</Trans>
    </p>
    <p className="text-sm text-muted">
      <Trans>
        We are fetching your recent Deadlock matches. It usually takes under a minute, the list will
        update by itself.
      </Trans>
    </p>
  </div>
);
